import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as PConstants from '../../common/constants';
import { MenuItem } from '../index';
import { useAuth } from '../../../model/hooks';
const useStyles = makeStyles((theme) => createStyles({
    // toolbarの高さ分をメニュー上部に確保
    toolbar: theme.mixins.toolbar,
}));
export const SideMenu = (props) => {
    const { isOpen, onClose } = props;
    const bodyContainer = window !== undefined ? () => window.document.body : undefined;
    const classes = useStyles();
    const location = useLocation();
    const { t } = useTranslation();
    const { logout } = useAuth();
    const hisotry = useHistory();
    // URLから選択マークつけるサイドメニューを判定
    const getSelectedMenu = (nowPath) => {
        const splitWords = nowPath.split('/');
        // /home or /home/[各メニュー]
        return splitWords.length > 2 ? `/${splitWords[1]}/${splitWords[2]}` : `/${splitWords[1]}`;
    };
    const [selectedMenuPath, setSelectedMenuPath] = useState(getSelectedMenu(location.pathname));
    const onClickMenu = async (value) => {
        if (value === 'LOGOUT') {
            await logout();
            hisotry.push('/');
        }
    };
    // URLが変更する度選択マークをつけるサイドメニューを指定
    useEffect(() => {
        setSelectedMenuPath(getSelectedMenu(location.pathname));
    }, [location.pathname]);
    const drawer = (React.createElement("div", null,
        React.createElement(SLogo, { className: classes.toolbar }, t('IMORY')),
        React.createElement(Divider, null),
        React.createElement(List, null, PConstants.MENU.map((val) => (React.createElement(MenuItem, { key: val.title, title: val.title, icon: val.icon, path: val.path, type: val.type, onClose: onClose, onClickMenu: onClickMenu, selected: selectedMenuPath === val.path, setSelectedMenuPath: setSelectedMenuPath }))))));
    return (React.createElement("nav", null,
        React.createElement(Hidden, { smUp: true },
            React.createElement(Drawer, { container: bodyContainer, variant: "temporary", open: isOpen, onClose: onClose, ModalProps: { keepMounted: true } }, drawer)),
        React.createElement(Hidden, { xsDown: true },
            React.createElement(Drawer, { variant: "permanent", open: true }, drawer))));
};
const SLogo = styled.div `
  background-color: ${PConstants.COLOR.AQUA_GREEN500};
  display: flex;
  align-items: center;
  padding-left: 24px;
  font-size: 24px;
  font-weight: bold;
`;
